<template>
  <div>


<el-container>
      <!-- 顶部 -->
  <el-header> 
    <div>
      <div class="bamtopclass">老师管理系统</div>
      <div class="removeLogin"><el-button type="primary" @click="outlogin"> 退出登录</el-button></div>
      <div><span class="username">{{username}}</span></div>
    </div>
    

   
  </el-header>
  <el-container class="home_class">
    <el-aside width="200px">
          <!-- 左侧 -->
    <el-menu router>

      <!-- 一级菜单 -->
      <el-submenu index="1">
          <!-- 一级菜单模块区域 -->
        <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-xueshengguanli"></span>
          <span>学生管理</span>
        </template>
          <!-- 二级菜单 -->
        <el-menu-item-group>
          <el-menu-item index="ViewStudentWork">
             <template slot="title">
              <!-- 图标 -->
         <span class="iconfont icon-wentihuibao"></span>
          <span @click="report">学生汇报查看</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="asViewStudentIelts">
             <template slot="title">
              <!-- 图标 -->
         <span class="iconfont icon-xinzeng"></span>
          <span>学生雅思申报记录</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>
               <el-menu-item-group>
          <el-menu-item index="ReadExcell">
             <template slot="title">
              <!-- 图标 -->
        <span class="iconfont icon-daoru"></span>
          <span>学生成绩导入</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="IeltsText">
             <template slot="title">
              <!-- 图标 -->
        <span class="iconfont icon-daoru"></span>
          <span>雅思模拟成绩导入</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="VieApponintment">
             <template slot="title">
              <!-- 图标 -->
        <span class="iconfont icon-daoru"></span>
          <span>学生预约查看</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="VieTeacherApponintment">
             <template slot="title">
              <!-- 图标 -->
        <span class="iconfont icon-daoru"></span>
          <span>已预约列表</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

         <!-- 一级菜单 -->
      <el-submenu index="6">
          <!-- 一级菜单模块区域 -->
        <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-huibao"></span>
          <span>听课记录</span>
        </template>
          <!-- 二级菜单 -->
        <el-menu-item-group>
          <el-menu-item index="Lectures">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span @click="report">填写听课记录</span>
        </template>
          </el-menu-item>

          <el-menu-item index="Supervise">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span >填写学风督查</span>
        </template>
          </el-menu-item>

     <el-menu-item index="ViewTeahcherLectures">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span @click="report">查看听课记录</span>
        </template>
          </el-menu-item>
          <el-menu-item index="ViewSupervise">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span>查看学风督查</span>
        </template>
          </el-menu-item>

        </el-menu-item-group>
                  <!-- 二级菜单 -->
                

          
      
      </el-submenu>
      

            <!-- 一级菜单 -->
            <el-submenu index="2">
          <!-- 一级菜单模块区域 -->
        <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-huibao"></span>
          <span>工作汇报</span>
        </template>
          <!-- 二级菜单 -->
        <!-- <el-menu-item-group>
          <el-menu-item index="teacherPeport">
             <template slot="title">
           <span class="iconfont icon-wentihuibao"></span>
          <span @click="report">工作汇报查看</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group> -->
        <!-- <el-menu-item-group>
          <el-menu-item index="Kpi">
             <template slot="title">
  
           <span class="iconfont icon-wentihuibao"></span>
          <span @click="report">KPI填写</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="ViewTeacherKpi">
             <template slot="title">
           <span class="iconfont icon-wentihuibao"></span>
          <span @click="report">KPI查看</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group> -->
        <el-menu-item-group>
          <el-menu-item index="Accessory">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span @click="report">公告附件上传</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>

        <el-menu-item-group>
          <el-menu-item index="teacherPerformance">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span @click="report">周绩效填写</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="viewWeekTPerformance">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span @click="report">周绩效查看</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="viewMonthTPerformance">
             <template slot="title">
              <!-- 图标 -->
           <span class="iconfont icon-wentihuibao"></span>
          <span @click="report">月绩效查看</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
      </el-submenu>


      <el-submenu index="4">
          <!-- 一级菜单模块区域 -->
        <template slot="title">
              <!-- 图标 -->
         <span class="iconfont icon-gerenxinxi1"></span>
          <span>文件管理</span>
        </template>
          <!-- 二级菜单 -->
              <el-menu-item-group>
          <el-menu-item index="CloudFile">
             <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-yonghuguanli"></span>
          <span>文件上传</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="PublicCloudFile">
             <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-yonghuguanli"></span>
          <span>公用文件</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="11">
        <template slot="title">
         <span class="iconfont icon-gerenxinxi1"></span>
          <span>调查问卷</span>
        </template>
              <el-menu-item-group>
          <el-menu-item index="Questionnaire">
             <template slot="title">
          <span class="iconfont icon-yonghuguanli"></span>
          <span>调查问卷</span>
        </template>
          </el-menu-item>
        
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="ViewQuestionnaire">
             <template slot="title">
          <span class="iconfont icon-yonghuguanli"></span>
          <span>调查问卷查看</span>
        </template>
          </el-menu-item>
        
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="teacherAnswerQuestion">
             <template slot="title">
          <span class="iconfont icon-yonghuguanli"></span>
          <span>调查问卷填写</span>
        </template>
          </el-menu-item>
        
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="3">
          <!-- 一级菜单模块区域 -->
        <template slot="title">
              <!-- 图标 -->
         <span class="iconfont icon-gerenxinxi1"></span>
          <span>个人信息</span>
        </template>
          <!-- 二级菜单 -->
              <el-menu-item-group>
          <el-menu-item index="TeacherEVPI">
             <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-yonghuguanli"></span>
          <span>个人信息完善</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>

                  <!-- 二级菜单 -->
                  <el-menu-item-group>
          <el-menu-item index="TeacherClass">
             <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-yonghuguanli"></span>
          <span>授教信息</span>
        </template>
          </el-menu-item>
          
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
 
    </el-aside>

    <el-container>
      <el-main>

        <router-view></router-view>
        
        </el-main>
      <el-footer>Footer</el-footer>
    </el-container>
  </el-container>
</el-container>
  </div>
</template>

<script>
import "@/components/work/until/icon/iconfont.css"
export default {
  created(){
    this.newscli()
  },
  methods:{
    newscli(){
      this.username=JSON.parse(localStorage.getItem('user')).username 
    },
    report(){
    
    },
    outlogin(){
      localStorage.removeItem('user');
      localStorage.removeItem('token');
       this.$router.push({  
                    name: 'Login',  
                  })
    }
  },data(){
      return{
        username:''
      }}

}
</script>

<style scoped>
 .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
    min-width: 1400px;

  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    line-height: 200px;
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    min-width: 1200px;
 
  }
  .home_class{
    height: 800px;
  }
  .removeLogin{
   float:right;
  }
 .bamtopclass{
  float: left;
  padding-left: 45%;
 }.username{
  padding-left: 38%;
}
</style>


// WEBPACK FOOTER //
// src/components/work/teacher/TeacherBam.vue